export default "<p>privacy-policy works!</p>\n"